import React, { FC, lazy, Suspense, useEffect, useState } from "react";
import { useCart } from "../../../context/CartContext";
import MainText from "../../../components/text/MainText";
import NumberFormat from "../../../components/text/NumberFormat";
import MainButton from "../../../components/buttons/MainButton";
import { Product } from "../../../models/Product";

type Props = {
  title?: string;
  protitle?: string;
  image?: string;
  slug?: string;
  description?: string;
  logo?: string;
  className?: string;
  bgColor?: string;
  colClass?: string;
  btnText?: string;
  btnLogo?: string;
  btnFullWidth?: string;
  imageClass?: string;
  titleClass?: string;
  price?: string;
  textLink?: string;
  shadow?: boolean;
  product?: Product;
  projectName?: string;
  alt_key?: string;
  is_subscribed?: boolean;
  id?: number;
  disabled?: boolean;
  onSelect?: (id: number, isChecked: boolean) => void;
  isChecked?: boolean;
};

// Lazy load ProductNumber modal
const LazyProductNumber = lazy(() => import("../../../components/modals/ProductNumber"));

const PlanProductOne: FC<Props> = ({
  colClass,
  shadow,
  price,
  textLink,
  bgColor,
  titleClass,
  title,
  protitle,
  imageClass,
  image,
  slug,
  description,
  logo,
  className,
  btnText,
  btnLogo,
  btnFullWidth,
  product,
  projectName,
  is_subscribed,
  id,
  alt_key,
  disabled,
  onSelect,
  isChecked,
}) => {
  const [numberModalIsOpen, setNumberModalIsOpen] = useState(false);
  const [isCheckedState, setIsCheckedState] = useState(isChecked);
  useEffect(() => {
    setIsCheckedState(isChecked);
  }, [isChecked]);

  const handleToggleSelection = () => {
    const newCheckedState = !isCheckedState; 
    setIsCheckedState(newCheckedState);
    onSelect!(id!, newCheckedState); 
  };
  const {
    addToCart,
    toCartItem,
    disableAddToCart,
    disableGiftNow,
    setDisableAddToCart,
    setDisableGiftNow,
  } = useCart();
  const [isGift, setIsGift] = useState<any>();

  const openNumberModal = () => {
    setNumberModalIsOpen(true);
    setIsGift(false);
  };

  const closeNumberModal = () => {
    setNumberModalIsOpen(false);
  };

  return (
    <div className={`${colClass} pt-2 pb-2 ${className}`}>
      <div
        className={`card-layout ${bgColor} card card-custom card-stretch`}
      >
        <div className="card-body d-flex flex-column">
          <div className="flex-grow-1 pb-3">
            <div className={"text-center"}>
              <img
                src={image}
                className={`w-100 ${imageClass} bdr-15`}
                alt={alt_key}
              />
              {shadow && (
                <img
                  src={"/assets/images/home/shadow.png"}
                  className={"w-50"}
                  alt={""}
                />
              )}
            </div>

            <div className={"mt-4"}>
              {/* <SecondaryTitle
                className={`primary-title ${titleClass}`}
                text={title}
              /> */}
              <h3 className={`primary-title ${titleClass}`}>{title}</h3>
              <h2 className={`primary-title ${titleClass}`}>{protitle}</h2>
            </div>
            {projectName && (
              <div className={"main-p f-title-bold letter-spacing"}>
                {projectName}
              </div>
            )}
            {logo && (
              <div className={"text-center"}>
                <img src={logo} className={"w-50"} alt={"logo"} />
              </div>
            )}

            <MainText
              className={"main-p text-color mt-4 mb-4 "}
              text={description}
            />
          </div>
          <div className="align-items-center text-center">
            {price && (
              <div className={"text-light-green mt-2"}>
                USD {<NumberFormat value={price} />}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlanProductOne;